module.exports = __webpack_public_path__ + "static/media/remy.4dfcd934.jpg";